import { graphql } from 'react-relay';
import { createOperationDescriptor, getRequest } from 'relay-runtime';

import { getAggRelayEnvironment } from '@townsquare/relay-utils/agg-environment';

import { JiraSpaceOption } from '../types/SpaceInputTypes';

import { getIsAdminFromStoreQuery$data } from './__generated__/getIsAdminFromStoreQuery.graphql';

const isValidQueryData = (data: unknown): data is getIsAdminFromStoreQuery$data => {
	return data !== null && typeof data === 'object' && 'jira' in data;
};

export const getIsAdminFromStore = (
	selectedSpace: JiraSpaceOption | undefined,
	cloudId: string | null | undefined,
): boolean => {
	if (!selectedSpace || !cloudId) {
		return false;
	}

	const environment = getAggRelayEnvironment();
	const operation = createOperationDescriptor(
		getRequest(graphql`
			query getIsAdminFromStoreQuery($cloudId: ID!, $projectKey: String!) {
				jira {
					isProjectAdmin: hasProjectPermission(
						cloudId: $cloudId
						permission: ADMINISTER_PROJECTS
						projectKey: $projectKey
					) @optIn(to: "JiraHasProjectPermissionQuery")
					isGlobalAdmin: hasGlobalPermission(cloudId: $cloudId, key: ADMINISTER)
						@optIn(to: "JiraHasGlobalPermission")
				}
			}
		`),
		{ cloudId, projectKey: selectedSpace.key },
	);

	const snapshot = environment.lookup(operation.fragment);

	if (!snapshot.isMissingData && isValidQueryData(snapshot.data)) {
		return !!snapshot.data.jira?.isProjectAdmin || !!snapshot.data.jira?.isGlobalAdmin;
	}

	return false;
};
